import { render, staticRenderFns } from "./RelationAccount.vue?vue&type=template&id=e34624d8&scoped=true"
import script from "./RelationAccount.vue?vue&type=script&lang=js"
export * from "./RelationAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e34624d8",
  null
  
)

export default component.exports